module.exports = __webpack_public_path__ + "static/ql_book-24c33e20fff5c08a06bf12ea2404e0fe.jpg";